import { FunctionComponent, MouseEvent, ReactNode, useContext } from "react";

import { PMC_LEGAL_URLS } from "@ui/components/navigation/Footer/data/pmcLegalUrls";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import CookieConsentContext from "@voxmedia/duet-context/context/cookie-consent-context";

import * as footerLinkStyles from "./FooterLinks.css";
import PrivacyChoicesIcon from "./PrivacyChoicesIcon";

interface Props {
  className?: string;
  iconClassName?: string;
  showIcon?: boolean;
}

export const PmcPrivacyChoicesLink: FunctionComponent<Props> = ({
  className,
  iconClassName,
  showIcon = false,
}) => {
  const analytics = useAnalytics();
  const cookieConsent = useContext(CookieConsentContext);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    analytics?.emit({
      event: "footer_click",
      footer_click: { name: "Your Privacy Choices" },
    });

    if (cookieConsent && !cookieConsent.isOneTrustLoading) {
      event.preventDefault();
      cookieConsent.toggleCookiesConsentDrawer();
    }
  };

  return (
    <a
      className={className}
      href={PMC_LEGAL_URLS.yourPrivacyChoices}
      rel="nofollow"
      onClick={handleClick}
    >
      {showIcon && <PrivacyChoicesIcon className={iconClassName} />}
      Your Privacy Choices
    </a>
  );
};

const pmcPrivacyChoicesFooterLink: ReactNode = (
  <PmcPrivacyChoicesLink className={footerLinkStyles.link} />
);

export default pmcPrivacyChoicesFooterLink;
